import React, { useState } from 'react'
import AddIcon from '@mui/icons-material/Add';
import EditIcon from '@mui/icons-material/Edit';
import BoxForm from './BoxForm';
import MyButton from '../../../../UI/form/MyButton';
import MyModal from '../../../../UI/modal/MyModal';
import AddBoxIcon from '@mui/icons-material/AddBox';

const BoxFormAdd = ({ packId, box }) => {

    const [open, setOpen] = useState(false)

  return (
    <>
        <MyButton
            onClick={e => setOpen(true)}
        >
            {
                box ? <EditIcon /> : <AddBoxIcon />
            }
        </MyButton>

        <MyModal
            open={open}
            setOpen={setOpen}
            header={'Додати коробку'}
            disableClickOutside={true}
            content={
                <BoxForm
                    packId={packId}
                    boxBd={box}
                    setOpen={setOpen}
                />
            }
        />
    </>
  )
}

export default BoxFormAdd